"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import ContentfulPreviewProvider from "@packages/lib/contentful-preview/ContentfulLivePreviewProvider";
import Subscribecomponents from "@packages/shared-components/common-utilities/newsletter-and-subscription/subscribe-newsletter/subscribecomponents";
import UniversityTab from "@packages/shared-components/common-utilities/searchBar/search-input-pods/universitytab";
import { getInYearAjax } from "@packages/shared-components/common-utilities/searchBar/search-utils/search-api";
import { graphQlFetchFunction } from "@packages/lib/server-actions/server-action";
import { FIND_A_COURSE } from "@packages/lib/graphQL/find-a-course";

export default function OpenDaysNotFound() {
  const [universityData, setUniversityData] = useState<any[]>([]);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [searchFormHandle, setSearchFormHandle] = useState({
    activeTab: "tab1",
    isCourseType: false,
    isSubjectClicked: false,
    isLocationClicked: false,
    isAdviceClicked: false,
    isUniversityClicked: false,
    courseType: { qualUrl: "degree", qualCode: "M", qualDesc: "Undergraduate" },
    
    university: "",
    subject: {},
    location: {},
    advice: "",
  });

  useEffect(() => {
    const fetchUniversities = async () => {
      const response = await getInYearAjax("INSTITUTION");
      console.log(response, "response")
      setUniversityData(Array.isArray(response) ? response : []);
    };

    const fetchImage = async () => {
      const clearing = process.env.NEXT_PUBLIC_CLEARING_FLAG === "ON";
      const contents = await graphQlFetchFunction(FIND_A_COURSE(clearing));
      const bottomZoneItems =
        contents?.data?.pageTemplateDynamicPageCollection?.items?.[0]
          ?.bottomZoneComponentsCollection?.items || [];
      const findACourseCard =
        bottomZoneItems?.[0]?.mediaCardsCollection?.items?.find(
          (item: any) => item?.sectionTitle?.toLowerCase() === "find  a course"
        );
      setImageUrl(findACourseCard?.linkPanelImage?.url || "");
    };

    fetchUniversities();
    fetchImage();
  }, []);

  return (
    <ContentfulPreviewProvider
      locale="en-GB"
      enableInspectorMode={false}
      enableLiveUpdates={false}
      debugMode={false}
    >
      <>
        <div className="max-w-container mx-auto">
          <div className="px-[16px] md:px-[20px] xl:px-0 py-[40px] md:py-[56px]">
            <div className="flex gap-[16px]">
              <div className="flex flex-col gap-[4px]">
                <div className="para-lg font-bold font-farro">
                  Well, that&apos;s unexpected!
                </div>
                <div className="small">
                  We couldn&apos;t find any matches for{" "}
                  {window.location.pathname
                    ?.split("/")[2]
                    ?.split("-")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </div>
                <ul className="list-disc small mt-[20px] ml-[20px]">
                  <li>
                    Not what you expected? Try a new search term or check for
                    typos.
                  </li>
                  <li>Let&apos;s find what you&apos;re looking for!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <section className="bg-orange-100">
          <div className="max-w-container mx-auto">
            <div className="flex flex-col-reverse md:flex-row justify-between gap-[16px] p-[16px] md:p-[0_20px_26px_20px] lg:py-0 xl:px-0 min-h-[194px]">
              <div className="w-full flex flex-col flex-grow gap-[16px] self-center lg:p-[16px_0]">
                <div className="flex flex-col gap-[4px]">
                  <h2 className="text-heading1 md:text-heading-xl">
                    Your uni search made easier
                  </h2>
                  <div>
                    Find{" "}
                    <span className="font-semibold">open days, </span>
                    read <span className="font-semibold">honest reviews, </span>
                    get <span className="font-semibold">expert advice</span>
                  </div>
                </div>

                <div className="w-full lg:min-w-[680px] lg:max-w-[825px]">
                  <div className="flex flex-col gap-[24px] min-h-[60px]">
                    {universityData.length > 0 && (
                      <UniversityTab
                        placeholder="University name"
                        searchFormHandle={searchFormHandle}
                        setsearchFormHandle={setSearchFormHandle}
                        data={universityData}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="flex self-end justify-center w-full shrink-0 md:w-[219px] lg:w-[392px] pt-[12px]">
                <div className="w-[108px] md:w-[186px] lg:w-[205px]">
                  {imageUrl && (
                    <Image
                      src={imageUrl}
                      className="w-full"
                      width={205}
                      height={260}
                      priority
                      alt="Find a university"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Subscribecomponents pageGrouping="Error Page" />
      </>
    </ContentfulPreviewProvider>
  );
}
